/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EntityAttachmentsListResponse } from '../../models/entity-attachments-list-response';

export interface AttachmentsControllerDeleteAttachment$Params {
  entity: 'agreement' | 'asset_management' | 'ddt' | 'delivery' | 'order' | 'order_customer' | 'schedule' | 'ticket' | 'warehouse';
  id: number;
  type: number;
  media_id: number;
}

export function attachmentsControllerDeleteAttachment(http: HttpClient, rootUrl: string, params: AttachmentsControllerDeleteAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityAttachmentsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, attachmentsControllerDeleteAttachment.PATH, 'delete');
  if (params) {
    rb.path('entity', params.entity, {});
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.path('media_id', params.media_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EntityAttachmentsListResponse;
      }>;
    })
  );
}

attachmentsControllerDeleteAttachment.PATH = '/attachments/{entity}/{id}/{type}/{media_id}';
